angular.module('zc.core')
  .factory('areaChartV2Config', areaChartV2Config);

areaChartV2Config.$inject = ['chronologicalChartV2Config'];
function areaChartV2Config(chronologicalChartV2Config) {
  return angular.merge({
    options: {
      chart: { type: 'area' },
    }
  }, chronologicalChartV2Config);
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/area_chart_v2_config.service.js